import { render, staticRenderFns } from "./processTrans.vue?vue&type=template&id=2e6427f6&"
import script from "./processTrans.vue?vue&type=script&lang=js&"
export * from "./processTrans.vue?vue&type=script&lang=js&"
import style0 from "./processTrans.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "processTrans.vue"
export default component.exports